import React from 'react';
import { Layers } from 'lucide-react';
import { cn } from '@utils/classNames';

export interface ManageVersionsButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** Accent when the group has linked versions */
  hasVersions?: boolean;
  className?: string;
}

export const ManageVersionsButton: React.FC<ManageVersionsButtonProps> = ({
  onClick,
  hasVersions = true,
  className,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    onClick(e);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title="Manage versions"
      aria-label="Manage versions"
      className={cn(
        'inline-flex items-center justify-center rounded-lg transition-colors touch-manipulation',
        'min-h-[40px] min-w-[40px] p-2',
        hasVersions
          ? 'text-primary hover:bg-white/10'
          : 'text-white/35 hover:bg-white/5 hover:text-white/50',
        className
      )}
    >
      <Layers className="w-5 h-5 flex-shrink-0" />
    </button>
  );
};
